import { render, staticRenderFns } from "./PostMediaDropzone.vue?vue&type=template&id=fd230436"
import script from "./PostMediaDropzone.vue?vue&type=script&lang=ts"
export * from "./PostMediaDropzone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports